<div *ngIf="authCheck">
  <div id="hub-header-cont">
    <div class="inner-cont-primary">
      <div class="inner-cont-left">
        <div class="header-logo">
          <!-- <a class="header-logo-link" title="Homepage">
            <img src="assets/images/masterbrand-logo.png" alt="HSBC">
          </a> -->
        </div>
        <!-- <div class="item-devider"></div>
        <div class="app-name">Client Hub</div> -->
      </div>
      <div class="inner-cont-right">
        <button class="logout-btn" (click)="closeSecService()">Close</button>
        <!-- <div class="header-item">Permissions (Comming soon)</div>
        <div class="item-devider"></div>
        <div class="header-item">Applications</div> -->
        <div *ngIf="authSuccess" class="header-item">
          <div>{{displayName}}</div>
          <!-- <div>Last login: {{lastModified}}</div> -->
        </div>
        <div class="item-devider"></div>
      </div>
    </div>

    <div class="inner-cont-secondary">
      <h2 id="header-app-name">Securities Services Applications</h2>
    </div>
  </div>

  <div *ngIf="authSuccess">
    <div id="page-content-cont">
      <!-- <div id="homepage-top-cont">
        <div id="ssa-content">
        </div>
        <div id="ssa-content1">
          <div id="security-name">Securities Services Apps</div><br/><br/>
          <div id="security-desc">Welcome to the home for new Securities Services applications</div>
        </div>
      </div> -->
      <div id="page-content">
        <div id="app-names-list">
          <ng-container *ngFor="let app of applications; let i = index;">
              <li (click)="app.enabled && activeApp = i;" [ngClass]="{'active': activeApp == i, 'disabled': !app.enabled}" >
                {{app.name}} <span *ngIf="!app.enabled">- Coming Soon</span>
                <!-- <div [ngClass]="{'app-indicator': activeApp != i}"></div> -->
              </li>
          </ng-container>      
        </div>
        <div id="app-details">
          <div class="app-box-new" id="dv-app-bg">
            <div id="ssa-content">
            </div>
            <div id="ssa-content1">
              <h2 id="security-name">HSS Digital Vault</h2><br/>
              <div id="security-desc">Access digital copies of Physical Certificates stored within our HSS Custody Vault. Powered by Blockchain.</div>
              <div class="action-btn-cont">
                <button class="tertiary-btn" (click)="showMoreInfo = true;">More Info</button>
                <button class="primary-btn" (click)="navigateToHoldings()">Launch</button>
                <div id="launch-action" (click)="navigateToHoldings(false)" style="width:20px; height: 10px;"></div>
              </div>
            </div>
          </div>
          <!-- <div *ngIf="applications[activeApp].name == 'My Applications'" class="app-box">
            <div class="app-image" id="digital-vault-img"></div>
            <div>
              <div class="app-title">Digital Vault</div>
              <div class="app-desc">
                Access digital copies of physical certificates stored within our HSS Custody Vault. Powered by blockchain.
              </div>
            </div>
            <button class="app-action-btn" (click)="navigateToHoldings()">Launch</button>
          </div>

          <div *ngIf="applications[activeApp].name == 'Application Marketplace'" class="app-box">
            <div class="app-image" id="marketplace-img"></div>
            <div>
              <div class="app-title">{{applications[activeApp]}}</div>
              <div class="app-desc">
                  The application Marketplace is where you will be able to find out about a wide range of HSS Applications, speak to your Client Service 
                  Manager for more details.
              </div>
            </div>
            <button class="app-action-btn" [disabled]="true">Coming Soon</button>
          </div> -->
        </div>
      </div>
    </div>

    <div id="hub-footer-cont">
      <div id="link-bar">
        <div class="inner-cont">
          <div class="inner-cont-left">
              <div class="item-devider"></div>
            <div class="footer-item"><i class="icon icon-security-lock"></i><!--<span class="security-lock-icon custom-icon"></span>--><a (click)="footerLinksNavigate('ONLINE_SECURITY')">Online Security</a></div>
            <div class="item-devider"></div>
            <div class="footer-item"><i class="icon icon-global"></i><!--<span class="global-icon custom-icon"></span>--><a (click)="footerLinksNavigate('HSBC_GROUP')">HSBC Group</a></div>
            <div class="item-devider"></div>
            <div class="footer-item"><i class="icon icon-phone"></i><!--<span class="phone-icon custom-icon"></span>--><a (click)="footerLinksNavigate('CUSTOMER_SUPPORT')">Customer Support</a></div>
          </div>
          <div class="inner-cont-right">
            <!-- <div class="footer-item">Copyright HSBC Group 2019</div> -->
          </div>
        </div>
      </div>

      <div id="tnc-bar">
          <div class="inner-cont">
            <div class="inner-cont-left">
              <div class="footer-item"><a (click)="footerLinksNavigate('TERMS_AND_CONDITIONS')">Terms & Conditions of use</a></div>
              <div class="footer-item"><a (click)="footerLinksNavigate('PRIVACY_AND_DATA')">Privacy and data protection statement</a></div>
              <div class="footer-item"><a (click)="footerLinksNavigate('HSBCNET_CONDITIONS')">HSBCnet condition of national language use</a></div>
            </div>
            <div class="inner-cont-right">
              <div class="footer-item">© HSBC Bank plc 2019</div>
            </div>
          </div>
      </div>
    </div>
  </div>

  <div *ngIf="!authSuccess" style="width: 100%" class="ui-g ui-g-12">
    <div class="col-sm-3"></div>
    <div id="auth-failed" class="col-sm-6">
      <div style="font-size: 2.286em;">Authentication failed</div>
      <div>Please click <a [href]="hsbcNetUrl">here</a> to go to HSBC Net.</div>
      <div id="error-details">
        <div *ngIf="userDataError">Error: {{userDataError}}</div>
      </div>
    </div>
    <div class="col-sm-3"></div>
  </div>
</div>

<div *ngIf="!authCheck">
  <div id="initial-loading">
    <span style="font-size: 1.714em;">Loading</span> <b style="font-size: 2.286em;">Securities Services</b>
    <div *ngIf="!isIE"><p-progressSpinner [style]="{width: '50px', height: '50px'}" strokeWidth="5"></p-progressSpinner></div>
    <div *ngIf="isIE"><div class="loading">Loading&#8230;</div></div>
  </div>
</div>

<div *ngIf="showMoreInfo" class="popup-cont">
</div>

<p-dialog [(visible)]="showMoreInfo" [contentStyle]="{'width':'700px', 'minHeight':'512px'}">
    <p-header></p-header>
    <div id="popup-close" (click)="showMoreInfo = false;"><i class="icon icon-delete"></i><!--<span class="delete-icon custom-icon"></span>--></div>
    <div id="popup-app-content">
      <div id="popup-dv-image"></div>
      <h2 >HSS Digital Vault</h2>
      <div class="popup-app-desc">The Digital Vault makes it easy to access copies of Physical Certificates that your organisation holds within our HSS Custody Vault.</div>
      <ul class="popup-desc-items">
        <li>View and Download copies of your Physical Certificates</li>
        <li>Real time records synchonised with HSS Core Custody Platform</li>
        <li>View Transaction records and Holdings</li>
        <li>Powered and Secured with Blockchain Technology</li>
      </ul>
      <!-- <h4>Release Notes</h4>
      <div class="popup-app-desc">V.1.0 - October 2019</div>
      <ul class="popup-desc-items">
        <li>Inital Release</li>
        <li>Real time records synchonised with HSS Core Custody Platform</li>
        <li>View Transaction records and Holdings</li>
        <li>Powered and Secured with Blockchain Technology</li>
      </ul> -->
    </div>
    <p-footer></p-footer>
</p-dialog>

<!-- <p-dialog [(visible)]="authFail">
  <p-header></p-header>
  <div id="popup-app-content" style="border: 0px;">
    Authentication Failed.
    Click <a [href]="hsbcNetUrl">here</a> to redirect to HSBC Net.
  </div>
  <p-footer></p-footer>
</p-dialog> -->